<template>
    <div>
        <div :class="{'visibility-hidden' : (isModalVisible && isMobile)}">
            <loader v-if="!loaded || processing"></loader>

            <div class="row" v-if="loaded">
                <div class="col-md-8">
                    <div class="dro">
                        <button type="button"
                                class="btn btn-light btn-sm  mb-1"
                                @click.prevent="backToPreviousPage()">
                            <i class="material-icons mdc-button__icon">arrow_back</i>
                            <span>{{'buttons.back_to_client' | trans}} {{client.code}} ({{client.hash}})</span>
                        </button>
                        <h4 class="dro__title">{{'dro.title' | trans}}</h4>
                        <p class="dro__subtitle">{{'dro.interactive_module_one' |
                            trans}}</p>
                        <p class="dro__description">{{'dro.description' | trans}}</p>
                    </div>

                    <settings-form v-if="!isCurrentUserStartedSessionBlock"
                                   :settings="form"
                                   v-on:session-settings-set="onSessionSettingsSet">
                    </settings-form>

                    <div class="row" v-if="isCurrentUserStartedSessionBlock">
                        <div class="col-md-12">
                            <settings-table></settings-table>
                            <current-interval-form
                                    v-on:save-session="onSaveSession"></current-interval-form>
                            <interval-list v-if="isIntervalsNotEmpty"></interval-list>
                        </div>
                    </div>


                </div>
                <div class="col-md-4 mt-4 mt-md-0">
                    <instruction :text="'dro.instructions.text' | trans"
                                 :header="'dro.instructions.header' | trans"
                                 :short-text-length="300">
                    </instruction>
                </div>
            </div>
            <dashboard-menu :hideDroModal=hideDroModal></dashboard-menu>

        </div>

        <div v-if="isModalVisible">
            <report-modal :visible="isModalVisible"
                          v-on:close="onClose">
            </report-modal>
        </div>


    </div>
</template>

<script>
  import Loader from '../../loader/components/Loader';
  import SettingsForm from './SettingsForm';
  import SettingsTable from './SettingsTable';
  import Instruction from '../../../common/instruction/components/InstructionView';
  import CurrentIntervalForm from './CurrentIntervalForm';
  import ReportModal from './ReportModal';
  import IntervalList from './IntervalList';
  import {showModal} from '../../../common/mixins/showModal';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import Manager from '../api/Manager';
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';
  import {loadDroInitData} from '../../../mixins/loadDroInitData';
  import axios from 'axios';

  export default {
    data() {
      return {
        processing: false,
        isModalVisible: false,
        hideDroModal: true,
        apiUrl: '/users/clients/',
        client: {},
      };
    },
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
    },
    mixins: [showModal, loadDroInitData],
    components: {
      IntervalList,
      Loader,
      SettingsForm,
      SettingsTable,
      Instruction,
      CurrentIntervalForm,
      ReportModal,
      DashboardMenu,
    },

    created() {
      this.getClient(this.clientId);
    },

    computed: {
      ...mapState('dro/session', [
        'settings',
        'intervals',
        'assignee',
        'isSessionStarted',
        'uuid',
      ]),
      ...mapState(['route']),
      isIntervalsNotEmpty() {
        return !!this.intervals.length;
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('dro/session', [
        'shouldSessionBeSaved',
        'saveSessionData',
      ]),
    },
    methods: {
      ...mapActions('dro/session', [
        'clearSession',
      ]),

      async onSaveSession() {
        this.processing = true;
        if (this.shouldSessionBeSaved) {
          try {
            let {data: response} = await Manager.save(this.saveSessionData);
            if (!(response && response.data && response.data.id)) {
              throw new Error('Session wasn\'t saved');
            }
          } catch (e) {
            throw new Error('Unknown API error');
          }
        }
        this.onShowModalBtnClick();
        this.processing = false;
      },
      onClose() {
        this.loaded = false;
        this.onModalClose();
        this.clearSession();
        this.$router.push({name: 'dro', params: this.route.params});
      },
      backToPreviousPage() {
        this.$router.push({name: 'client-edit',params: {clientId: this.clientId}});
      },
      getClient: async function (clientId) {
        try {
          let response = await axios.get(this.apiUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        }
      },

    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/SessionLayout.vue